import { render, staticRenderFns } from "./VideoZoom.vue?vue&type=template&id=40fcc188&scoped=true&"
import script from "./VideoZoom.vue?vue&type=script&lang=ts&"
export * from "./VideoZoom.vue?vue&type=script&lang=ts&"
import style0 from "./VideoZoom.vue?vue&type=style&index=0&id=40fcc188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fcc188",
  null
  
)

export default component.exports